

export const caretakerInitalValues = {
  "firstName": "",
  "middleName": "",
  "lastName": "",
  "email": "",
  "phone": "",
  "status": "",
  "gender": "",
  "dateOfBirth": "",
  "street": "",
  "city": "",
  "state": "",
  "zipcode": "",
  "assignedOrganizations": [],
  "permissions": [],
  "type": ""
}


export const step1OrgInitialValues = {
  ownerFirstName: "",
  ownerMiddleName: "",
  ownerLastName: "",
  organizationName: "",
  providerGroupNPI: "",
  providerGroupType: "Provider NPI",
  phoneNumber: "",
  email: "",
  // US timezone for the organization (IANA format); API key: `timezone`
  timezone: "America/New_York",
  address: "",
  street: "",
  city: "",
  state: "",
  zipCode: "",
  // address2: "",
  // street2: "",
  // city2: "",
  // state2: "",
  // zipCode2: "",
};

export const step2OrgInitialValues = {
  billerFirstName: "",
  billerMiddleName: "",
  billerLastName: "",
  billerPhoneNumber: "",
  billerEmail: "",
  billerLocation: "",
  billerAddress: "",
  billerStreet: "",
  billerCity: "",
  billerState: "",
  billerZipCode: "",
  // billingPortalUsed: "",
};

export const step3OrgInitialValues = {
  groupName: "",
  billingAddress: "",
  billingStreet: "",
  billingCity: "",
  billingState: "",
  billingZipCode: "",
  primaryFax: "",
  primaryPhoneNumber: "",
  groupTaxId: "",
  groupNPI: "",
  ptan: "",
  tradingPartnerId: "",
  tin: "",
  medicalId: "",
  taxonomyCode: "",
};

export const organizationInitialValues = {
  ...step1OrgInitialValues,
  ...step2OrgInitialValues,
  ...step3OrgInitialValues,
};
